"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureAnnotationsMask = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _ccxIngest = require("@ccx-public/ccx-ingest");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _AppContext = require("../context/AppContext");

var _annotations = require("../selectors/annotations");

var ContextActions = _interopRequireWildcard(require("../actions/context"));

var _AnnotationsMask = _interopRequireDefault(require("../containers/AnnotationsMask"));

var _Root = _interopRequireDefault(require("../wrappers/Root"));

var _constants = require("../constants");

var _index = require("../reducers/index");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * AnnotationsMask component
 */
var AnnotationsMask = /*#__PURE__*/function (_React$Component) {
  _inherits(AnnotationsMask, _React$Component);

  var _super = _createSuper(AnnotationsMask);

  /**
   * Constructor for AnnotationsMask
   * @param {object} props - props sent to the component
   * @returns {undefined}
   */
  function AnnotationsMask(props) {
    var _this;

    _classCallCheck(this, AnnotationsMask);

    _this = _super.call(this, props);
    _this.state = {
      hadError: false
    };
    return _this;
  }
  /**
   * Lifecycle method for updating state for an error boundary
   * @returns {undefined}
   */


  _createClass(AnnotationsMask, [{
    key: "componentDidCatch",

    /**
     * Lifecycle method for catching an error
     * @param {object} error - error captured by error handler
     * @returns {undefined}
     */
    value: function componentDidCatch(error) {
      var _this$props = this.props,
          ccxIngest = _this$props.ccxIngest,
          environment = _this$props.environment;
      ccxIngest.fireEvent({
        event: {
          subcategory: 'general-error',
          subtype: 'error',
          type: 'render',
          error_type: error.message && error.message.replace(/\s/g, '-'),
          error_desc: 'annotations-mask-js-error',
          build: environment
        }
      });
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var hadError = this.state.hadError;

      if (hadError) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_Root.default, {
        style: {
          backgroundColor: 'transparent',
          height: '100%',
          left: 0,
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          width: '100%',
          zIndex: 3
        }
      }, /*#__PURE__*/_react.default.createElement(_AnnotationsMask.default, this.props));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hadError: true
      };
    }
  }]);

  return AnnotationsMask;
}(_react.default.Component);

exports.PureAnnotationsMask = AnnotationsMask;
AnnotationsMask.propTypes = {
  ccxIngest: _propTypes.default.object,
  environment: _propTypes.default.string,
  style: _propTypes.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasAnnotationLocation: (0, _annotations.getHasAnnotationLocation)(state),
    drawingNode: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":annotation.drawingNode")),
    isPlacingAnnotation: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.isPlacingAnnotation")),
    newAnnotationType: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.newAnnotationType")),
    showAnnotationMask: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.showAnnotationMask")),
    viewingUnmapped: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.viewingUnmapped"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setUnmappedView: ContextActions.contextSetUnmappedView
  }, dispatch);
};

var enhance = (0, _redux.compose)(_AppContext.withAppContext, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _index.reduxContext
}), (0, _ccxIngest.ccxIngest)(_constants.INGEST_PROJECT_VALUE));

var _default = enhance(AnnotationsMask);

exports.default = _default;